jQuery(document).ready(function ($) {
  var initialized = false;

  // 地図表示用メソッド
  function initMap() {
    if (initialized) {
      return;
    }

    var hasAdvancedMarker =
      typeof google !== "undefined" &&
      google.maps &&
      google.maps.marker &&
      typeof google.maps.marker.AdvancedMarkerElement === "function";

    if (
      typeof google === "undefined" ||
      !google.maps ||
      typeof google.maps.Map !== "function" ||
      typeof google.maps.LatLng !== "function" ||
      typeof google.maps.InfoWindow !== "function" ||
      (!hasAdvancedMarker && typeof google.maps.Marker !== "function")
    ) {
      return;
    }

    initialized = true;

    // ピン先端を画面中央寄りに見せるため、中心座標を少し北へずらす
    var centerLatOffset = 0.00025;
    function getAdjustedCenter(latlng) {
      return {
        lat: latlng.lat() + centerLatOffset,
        lng: latlng.lng(),
      };
    }

    // 地図の座標を設定
    var latlng_TYO = new google.maps.LatLng(35.643102, 139.699446);
    var latlng_OSK = new google.maps.LatLng(34.69123, 135.496899);

    // 地図の設定

    // 東京
    var mapTYO = new google.maps.Map(document.getElementById("maps-tokyo"), {
      zoom: 17, // 地図の拡大率
      center: getAdjustedCenter(latlng_TYO), // 地図の中心座標（少し北へ補正）
      scrollwheel: false, // マウスホイールでの拡縮を禁止
      mapTypeControl: false, // 「地図 / 航空写真」ボタンを非表示
      mapId: "DEMO_MAP_ID", // AdvancedMarkerElementに必要（本番では専用Map ID推奨）
    });

    // 大阪
    var mapOSK = new google.maps.Map(document.getElementById("maps-osaka"), {
      zoom: 17, // 地図の拡大率
      center: getAdjustedCenter(latlng_OSK), // 地図の中心座標（少し北へ補正）
      scrollwheel: false, // マウスホイールでの拡縮を禁止
      mapTypeControl: false, // 「地図 / 航空写真」ボタンを非表示
      mapId: "DEMO_MAP_ID", // AdvancedMarkerElementに必要（本番では専用Map ID推奨）
    });

    // マーカー画像の設定
    var markerImg = {
      url: "/wp-content/themes/kwh/assets/img/map_pin.webp", // 絶対パスで指定してページ階層の影響を受けないようにする
      scaledSize: new google.maps.Size(46, 67), // 画像のサイズが正しいことを確認
    };

    function createMarkerContent() {
      var markerImage = document.createElement("img");
      markerImage.src = markerImg.url;
      markerImage.width = 46;
      markerImage.height = 67;
      markerImage.alt = "";
      markerImage.style.width = "46px";
      markerImage.style.height = "67px";
      markerImage.style.maxWidth = "none";
      markerImage.style.display = "block";
      return markerImage;
    }

    function createMarker(map, position) {
      if (hasAdvancedMarker) {
        return {
          marker: new google.maps.marker.AdvancedMarkerElement({
            position: position,
            map: map,
            content: createMarkerContent(),
          }),
          isAdvanced: true,
        };
      }

      return {
        marker: new google.maps.Marker({
          position: position,
          map: map,
          icon: markerImg,
        }),
        isAdvanced: false,
      };
    }

    function openInfoWindow(infoWindow, map, markerData) {
      if (markerData.isAdvanced) {
        infoWindow.open({
          map: map,
          anchor: markerData.marker,
        });
        return;
      }

      infoWindow.open(map, markerData.marker);
    }

    function addMarkerClickListener(markerData, onClick) {
      if (markerData.isAdvanced) {
        markerData.marker.addEventListener("gmp-click", onClick);
        return;
      }

      markerData.marker.addListener("click", onClick);
    }

    // マーカーの設定
    // 東京
    var markerTYO = createMarker(mapTYO, latlng_TYO);

    // 大阪
    var markerOSK = createMarker(mapOSK, latlng_OSK);

    var infoWindowTYO = new google.maps.InfoWindow({
      // 吹き出しの追加
      content: "株式会社シー・エヌ・エス　東京オフィス", // 吹き出しに表示する内容
      disableAutoPan: true, // 初期表示時に地図中心がずれないようにする
    });
    addMarkerClickListener(markerTYO, function () {
      // マーカーをクリックしたとき
      openInfoWindow(infoWindowTYO, mapTYO, markerTYO); // 吹き出しの表示
    });
    openInfoWindow(infoWindowTYO, mapTYO, markerTYO);

    var infoWindowOSK = new google.maps.InfoWindow({
      content: "株式会社シー・エヌ・エス　大阪オフィス",
      disableAutoPan: true, // 初期表示時に地図中心がずれないようにする
    });
    addMarkerClickListener(markerOSK, function () {
      openInfoWindow(infoWindowOSK, mapOSK, markerOSK);
    });
    openInfoWindow(infoWindowOSK, mapOSK, markerOSK);

    //リサイズ
    window.addEventListener("resize", function () {
      var centerTYO = mapTYO.getCenter();
      google.maps.event.trigger(mapTYO, "resize");
      mapTYO.setCenter(centerTYO);

      var centerOSK = mapOSK.getCenter();
      google.maps.event.trigger(mapOSK, "resize");
      mapOSK.setCenter(centerOSK);
    });
  }

  // API読み込み完了を待ってから地図を初期化
  function waitForGoogleMaps() {
    initMap();
    if (!initialized) {
      window.setTimeout(waitForGoogleMaps, 100);
    }
  }

  waitForGoogleMaps();
});
